import produce from 'immer';
import {
  CHANGE_STATE,
  CREATE_FOLDER,
  CREATE_FOLDER_FAILED,
  CREATE_FOLDER_SUCCESS,
  FETCH_FOLDERS,
  FETCH_FOLDERS_FAILED,
  FETCH_FOLDERS_SUCCESS,
  UPDATE_FOLDER,
  UPDATE_FOLDER_FAILED,
  UPDATE_FOLDER_SUCCESS,
} from 'actions/folderActions';

const DEFAULT_FOLDER_SAVE_ERROR =
  'The page folder could not be saved. Please try again.';

const getFolderSaveErrorMessage = (error) => {
  if (typeof error === 'string' && error.trim()) {
    return error.trim();
  }

  if (error && typeof error.message === 'string' && error.message.trim()) {
    return error.message.trim();
  }

  return DEFAULT_FOLDER_SAVE_ERROR;
};

export const initialState = {
  folders: [],
  fetching: false,
  fetchSuccess: false,
  fetchFailed: false,
  statusText: null,
  submitting: false,
  createSuccess: false,
  createFailed: false,
  createError: '',
};

/* eslint-disable default-case, no-param-reassign */
const foldersReducer = (state = initialState, action) =>
  // eslint-disable-next-line consistent-return
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_FOLDERS:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        break;

      case FETCH_FOLDERS_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.folders = action.folders;
        break;

      case FETCH_FOLDERS_FAILED:
        draft.fetching = false;
        draft.fetchSuccess = false;
        draft.fetchFailed = true;
        draft.statusText = action.statusText;
        break;

      case CREATE_FOLDER:
        draft.submitting = true;
        draft.createFailed = false;
        draft.createSuccess = false;
        draft.createError = '';
        break;
      case CREATE_FOLDER_SUCCESS:
        draft.submitting = false;
        draft.createFailed = false;
        draft.createSuccess = true;
        draft.folders.push(action.pageFolder);
        draft.createError = '';
        break;
      case CREATE_FOLDER_FAILED:
        draft.submitting = false;
        draft.createFailed = true;
        draft.createSuccess = false;
        draft.createError = getFolderSaveErrorMessage(action.error);
        break;

      case CHANGE_STATE:
        draft.submitting = false;
        draft.createFailed = false;
        draft.createSuccess = false;
        draft.createError = '';
        break;
      case UPDATE_FOLDER:
        draft.submitting = true;
        draft.createFailed = false;
        draft.createSuccess = false;
        draft.createError = '';
        break;
      case UPDATE_FOLDER_SUCCESS:
        draft.submitting = false;
        draft.createFailed = false;
        draft.createSuccess = true;
        draft.folders = draft.folders.map((folder) =>
          folder._id === action.folder._id ? action.folder : folder
        );
        draft.createError = '';
        break;
      case UPDATE_FOLDER_FAILED:
        draft.submitting = false;
        draft.createFailed = true;
        draft.createSuccess = false;
        draft.createError = getFolderSaveErrorMessage(action.err);
        break;
    }
  });

export default foldersReducer;
